import React from 'react';
import { CategoryBadgeBrandsVariants } from '../config';
import { styled } from "../stitches.config"


interface CategoryBadgeProps {
    sponsored?: boolean;
    showMark?: boolean;
    text: string;
    markText?: string;
    categoryColor?: "default" | "primary" | "black" | "red" | Config.Brand;
}

const CategoryBadge: React.FC<CategoryBadgeProps> = ({
    sponsored = false,
    showMark = false,
    text,
    markText,
    categoryColor
}) => {
    return (
        <StyledCategoryBadge categoryColor={categoryColor} sponsored={sponsored}>
            <div>{text}</div> {showMark && markText && markText.length > 1 && <span>{markText}</span>}
        </StyledCategoryBadge>
    );
};

const StyledCategoryBadge = styled('div', {
    width: "max-content",
    display: "flex",
    alignItems: "center",
    '& div,& span': {
        borderRadius: "0px",
        backgroundColor: "$primary",
        color: "$textOnPrimary",
        fontFamily: "$grotesk",
        fontWeight: "$8",
        fontSize: "12px",
        lineHeight: "16px",
        padding: "2px 4px 2px 6px",
        whiteSpace: "nowrap"
    },
    '& div': {
        paddingLeft: "16px",
        position: "relative",
        '&:after,&:before': {
            content: "",
            position: "absolute",
            height: "5px",
            width: "5px",
            borderRadius: "50%",
            backgroundColor: "$textOnPrimary",
        },
        '&:after': {
            left: "6px",
            top: "4px"
        },
        '&:before': {
            left: "6px",
            top: "11px"
        }

    },
    '& span': {
        marginLeft: "6px",
    },
    variants: {
        sponsored: {
            true: {
                '& div,& span': {
                    backgroundColor: "$grayscale100",
                }
            },
        },
        categoryColor: {
            default: {
            },
            primary: {
                '& div,& span': {
                    backgroundColor: "$primary",
                }
            },
            black: {
                '& div,& span': {
                    backgroundColor: "$grayscale100Fixed",
                }
            },
            red: {
                '& div,& span': {
                    backgroundColor: "#EA3A3E",
                }
            },
            //Auto set brands variants bgColors
            ...CategoryBadgeBrandsVariants.categoryColorVariants
        }
    },
})


export default CategoryBadge